module.exports = __webpack_public_path__ + "img/white_youtube.a490f95d.svg";